// extracted by mini-css-extract-plugin
export var form = "_e0-0";